import { render, staticRenderFns } from "./RatingSummary.vue?vue&type=template&id=47056a82&"
import script from "./RatingSummary.vue?vue&type=script&lang=js&"
export * from "./RatingSummary.vue?vue&type=script&lang=js&"
import style0 from "./RatingSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports